/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActiveIngredientDto } from './ActiveIngredientDto';
import {
    ActiveIngredientDtoFromJSON,
    ActiveIngredientDtoFromJSONTyped,
    ActiveIngredientDtoToJSON,
    ActiveIngredientDtoToJSONTyped,
} from './ActiveIngredientDto';

/**
 * 
 * @export
 * @interface MedicineResponseDto
 */
export interface MedicineResponseDto {
    /**
     * Medicine ID
     * @type {string}
     * @memberof MedicineResponseDto
     */
    id: string;
    /**
     * Package NDC
     * @type {string}
     * @memberof MedicineResponseDto
     */
    packageNdc?: string;
    /**
     * Brand name base
     * @type {string}
     * @memberof MedicineResponseDto
     */
    brandNameBase?: string;
    /**
     * Brand name
     * @type {string}
     * @memberof MedicineResponseDto
     */
    brandName?: string;
    /**
     * Package description
     * @type {string}
     * @memberof MedicineResponseDto
     */
    description?: string;
    /**
     * Active ingredients
     * @type {Array<ActiveIngredientDto>}
     * @memberof MedicineResponseDto
     */
    activeIngredients?: Array<ActiveIngredientDto>;
    /**
     * Labeler name
     * @type {string}
     * @memberof MedicineResponseDto
     */
    labelerName?: string;
    /**
     * Dosage form
     * @type {string}
     * @memberof MedicineResponseDto
     */
    dosageForm?: string;
    /**
     * Route of administration
     * @type {Array<string>}
     * @memberof MedicineResponseDto
     */
    route?: Array<string>;
    /**
     * Medicine name (legacy - fallback from brandName)
     * @type {string}
     * @memberof MedicineResponseDto
     */
    name?: string;
    /**
     * Medicine code (legacy - fallback from packageNdc)
     * @type {string}
     * @memberof MedicineResponseDto
     */
    code?: string;
    /**
     * Created at
     * @type {Date}
     * @memberof MedicineResponseDto
     */
    createdAt: Date;
    /**
     * Updated at
     * @type {Date}
     * @memberof MedicineResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the MedicineResponseDto interface.
 */
export function instanceOfMedicineResponseDto(value: object): value is MedicineResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function MedicineResponseDtoFromJSON(json: any): MedicineResponseDto {
    return MedicineResponseDtoFromJSONTyped(json, false);
}

export function MedicineResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicineResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'packageNdc': json['packageNdc'] == null ? undefined : json['packageNdc'],
        'brandNameBase': json['brandNameBase'] == null ? undefined : json['brandNameBase'],
        'brandName': json['brandName'] == null ? undefined : json['brandName'],
        'description': json['description'] == null ? undefined : json['description'],
        'activeIngredients': json['activeIngredients'] == null ? undefined : ((json['activeIngredients'] as Array<any>).map(ActiveIngredientDtoFromJSON)),
        'labelerName': json['labelerName'] == null ? undefined : json['labelerName'],
        'dosageForm': json['dosageForm'] == null ? undefined : json['dosageForm'],
        'route': json['route'] == null ? undefined : json['route'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function MedicineResponseDtoToJSON(json: any): MedicineResponseDto {
    return MedicineResponseDtoToJSONTyped(json, false);
}

export function MedicineResponseDtoToJSONTyped(value?: MedicineResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'packageNdc': value['packageNdc'],
        'brandNameBase': value['brandNameBase'],
        'brandName': value['brandName'],
        'description': value['description'],
        'activeIngredients': value['activeIngredients'] == null ? undefined : ((value['activeIngredients'] as Array<any>).map(ActiveIngredientDtoToJSON)),
        'labelerName': value['labelerName'],
        'dosageForm': value['dosageForm'],
        'route': value['route'],
        'name': value['name'],
        'code': value['code'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

